var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('materials-tasks-toolbar',{attrs:{"title":"Materials Apps"}}),_c('addon-app-tab',{attrs:{"ui-location":"Materials Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }